import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationNameAlreadyTakenError = BaseErrorSchema.extend({
  errorType: z.literal('OrganizationNameAlreadyTakenError'),
  organizationName: z.string(),
});

export type OrganizationNameAlreadyTakenError = z.infer<
  typeof OrganizationNameAlreadyTakenError
>;
